"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Opcodes = void 0;
var Opcodes;
(function (Opcodes) {
    Opcodes[Opcodes["POP"] = 1] = "POP";
    Opcodes[Opcodes["RET"] = 2] = "RET";
    Opcodes[Opcodes["BR_TRUE"] = 3] = "BR_TRUE";
    Opcodes[Opcodes["BR_FALSE"] = 4] = "BR_FALSE";
    Opcodes[Opcodes["BRANCH"] = 5] = "BRANCH";
    Opcodes[Opcodes["LD_U64"] = 6] = "LD_U64";
    Opcodes[Opcodes["LD_CONST"] = 7] = "LD_CONST";
    Opcodes[Opcodes["LD_TRUE"] = 8] = "LD_TRUE";
    Opcodes[Opcodes["LD_FALSE"] = 9] = "LD_FALSE";
    Opcodes[Opcodes["COPY_LOC"] = 10] = "COPY_LOC";
    Opcodes[Opcodes["MOVE_LOC"] = 11] = "MOVE_LOC";
    Opcodes[Opcodes["ST_LOC"] = 12] = "ST_LOC";
    Opcodes[Opcodes["MUT_BORROW_LOC"] = 13] = "MUT_BORROW_LOC";
    Opcodes[Opcodes["IMM_BORROW_LOC"] = 14] = "IMM_BORROW_LOC";
    Opcodes[Opcodes["MUT_BORROW_FIELD"] = 15] = "MUT_BORROW_FIELD";
    Opcodes[Opcodes["IMM_BORROW_FIELD"] = 16] = "IMM_BORROW_FIELD";
    Opcodes[Opcodes["CALL"] = 17] = "CALL";
    Opcodes[Opcodes["PACK"] = 18] = "PACK";
    Opcodes[Opcodes["UNPACK"] = 19] = "UNPACK";
    Opcodes[Opcodes["READ_REF"] = 20] = "READ_REF";
    Opcodes[Opcodes["WRITE_REF"] = 21] = "WRITE_REF";
    Opcodes[Opcodes["ADD"] = 22] = "ADD";
    Opcodes[Opcodes["SUB"] = 23] = "SUB";
    Opcodes[Opcodes["MUL"] = 24] = "MUL";
    Opcodes[Opcodes["MOD"] = 25] = "MOD";
    Opcodes[Opcodes["DIV"] = 26] = "DIV";
    Opcodes[Opcodes["BIT_OR"] = 27] = "BIT_OR";
    Opcodes[Opcodes["BIT_AND"] = 28] = "BIT_AND";
    Opcodes[Opcodes["XOR"] = 29] = "XOR";
    Opcodes[Opcodes["OR"] = 30] = "OR";
    Opcodes[Opcodes["AND"] = 31] = "AND";
    Opcodes[Opcodes["NOT"] = 32] = "NOT";
    Opcodes[Opcodes["EQ"] = 33] = "EQ";
    Opcodes[Opcodes["NEQ"] = 34] = "NEQ";
    Opcodes[Opcodes["LT"] = 35] = "LT";
    Opcodes[Opcodes["GT"] = 36] = "GT";
    Opcodes[Opcodes["LE"] = 37] = "LE";
    Opcodes[Opcodes["GE"] = 38] = "GE";
    Opcodes[Opcodes["ABORT"] = 39] = "ABORT";
    Opcodes[Opcodes["NOP"] = 40] = "NOP";
    Opcodes[Opcodes["EXISTS"] = 41] = "EXISTS";
    Opcodes[Opcodes["MUT_BORROW_GLOBAL"] = 42] = "MUT_BORROW_GLOBAL";
    Opcodes[Opcodes["IMM_BORROW_GLOBAL"] = 43] = "IMM_BORROW_GLOBAL";
    Opcodes[Opcodes["MOVE_FROM"] = 44] = "MOVE_FROM";
    Opcodes[Opcodes["MOVE_TO"] = 45] = "MOVE_TO";
    Opcodes[Opcodes["FREEZE_REF"] = 46] = "FREEZE_REF";
    Opcodes[Opcodes["SHL"] = 47] = "SHL";
    Opcodes[Opcodes["SHR"] = 48] = "SHR";
    Opcodes[Opcodes["LD_U8"] = 49] = "LD_U8";
    Opcodes[Opcodes["LD_U128"] = 50] = "LD_U128";
    Opcodes[Opcodes["CAST_U8"] = 51] = "CAST_U8";
    Opcodes[Opcodes["CAST_U64"] = 52] = "CAST_U64";
    Opcodes[Opcodes["CAST_U128"] = 53] = "CAST_U128";
    Opcodes[Opcodes["MUT_BORROW_FIELD_GENERIC"] = 54] = "MUT_BORROW_FIELD_GENERIC";
    Opcodes[Opcodes["IMM_BORROW_FIELD_GENERIC"] = 55] = "IMM_BORROW_FIELD_GENERIC";
    Opcodes[Opcodes["CALL_GENERIC"] = 56] = "CALL_GENERIC";
    Opcodes[Opcodes["PACK_GENERIC"] = 57] = "PACK_GENERIC";
    Opcodes[Opcodes["UNPACK_GENERIC"] = 58] = "UNPACK_GENERIC";
    Opcodes[Opcodes["EXISTS_GENERIC"] = 59] = "EXISTS_GENERIC";
    Opcodes[Opcodes["MUT_BORROW_GLOBAL_GENERIC"] = 60] = "MUT_BORROW_GLOBAL_GENERIC";
    Opcodes[Opcodes["IMM_BORROW_GLOBAL_GENERIC"] = 61] = "IMM_BORROW_GLOBAL_GENERIC";
    Opcodes[Opcodes["MOVE_FROM_GENERIC"] = 62] = "MOVE_FROM_GENERIC";
    Opcodes[Opcodes["MOVE_TO_GENERIC"] = 63] = "MOVE_TO_GENERIC";
    Opcodes[Opcodes["VEC_PACK"] = 64] = "VEC_PACK";
    Opcodes[Opcodes["VEC_LEN"] = 65] = "VEC_LEN";
    Opcodes[Opcodes["VEC_IMM_BORROW"] = 66] = "VEC_IMM_BORROW";
    Opcodes[Opcodes["VEC_MUT_BORROW"] = 67] = "VEC_MUT_BORROW";
    Opcodes[Opcodes["VEC_PUSH_BACK"] = 68] = "VEC_PUSH_BACK";
    Opcodes[Opcodes["VEC_POP_BACK"] = 69] = "VEC_POP_BACK";
    Opcodes[Opcodes["VEC_UNPACK"] = 70] = "VEC_UNPACK";
    Opcodes[Opcodes["VEC_SWAP"] = 71] = "VEC_SWAP";
    Opcodes[Opcodes["LD_U16"] = 72] = "LD_U16";
    Opcodes[Opcodes["LD_U32"] = 73] = "LD_U32";
    Opcodes[Opcodes["LD_U256"] = 74] = "LD_U256";
    Opcodes[Opcodes["CAST_U16"] = 75] = "CAST_U16";
    Opcodes[Opcodes["CAST_U32"] = 76] = "CAST_U32";
    Opcodes[Opcodes["CAST_U256"] = 77] = "CAST_U256";
})(Opcodes = exports.Opcodes || (exports.Opcodes = {}));
